import { svg } from 'lit';

export const checkMarkIcon = svg`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <polygon points="19 6.59 9 16.59 5 12.59 3.59 14 9 19.41 20.41 8 19 6.59"/>
</svg>`;
